/**
 * Tell zod not to probe for `eval` — imported for its side effect, FIRST.
 *
 * Zod 4 compiles object schemas to functions when it can, and finds out whether
 * it can by trying: `new Function("")` inside a try/catch (`allowsEval` in
 * `zod/v4/core/util.js`). Under the Content-Security-Policy the edge sends
 * (`script-src 'self'`, no `'unsafe-eval'` — `infra/caddy/routes.caddy`) the
 * attempt is refused, zod catches the error and carries on interpreting. So
 * nothing breaks. But the refusal is still a POLICY VIOLATION, raised once on
 * every page load:
 *
 *   script-src blocked eval at /assets/index-….js:9
 *
 * Measured 2026-10-13 by `infra/scripts/csp-check.mjs`: 80 pages visited under
 * the shipped policy, 80 violations, every one of them this line. A policy that
 * reports a violation on every page is a policy whose reports nobody reads, and
 * the fix is not to allow `eval` — it is to not ask.
 *
 * `jitless` is zod's own switch for exactly this (its source says so: "strict
 * CSPs report the caught `new Function`"). With it set the probe is skipped and
 * schemas are interpreted, which is what happened under the policy anyway.
 *
 * ORDER. The probe runs lazily, at the first object parse, so this only has to
 * run before any schema is USED — but an import that parses at module scope
 * would beat a call made from `main.tsx`'s body. Hence a module of its own,
 * imported before everything that can reach a schema. `test/zod-csp.test.ts`
 * holds the import where it is.
 */
import { z } from "zod";

z.config({ jitless: true });
